"use client";

import { api } from "@/lib/api/api";
import { ApiClientError, CalendarSource } from "@gettactic/api";
import * as Sentry from "@sentry/nextjs";
import { useQuery } from "@tanstack/react-query";

export function useAuthorizedIntegrations() {
  const {
    data: authorizedIntegrations,
    error,
    isLoading
  } = useQuery({
    queryKey: ["calendar.getAuthorizedIntegrations"],

    queryFn: async () => {
      const [isGoogleAuthorized, isMicrosoftAuthorized] = await Promise.all([
        api.client.calendar.hasAuthorization(CalendarSource.Google),
        api.client.calendar.hasAuthorization(CalendarSource.Microsoft)
      ]);

      return { isGoogleAuthorized, isMicrosoftAuthorized };
    },

    meta: {
      shouldIgnoreGlobalErrorHandler: true
    }
  });
  const loadingAuthorizations = isLoading;
  return { authorizedIntegrations, loadingAuthorizations, error };
}

export function getAuthorizationUrl(
  source: CalendarSource,
  organizationId: string
) {
  return api.client.calendar.getAuthorizationUrl(source, organizationId);
}
